import type { Component } from 'vue'

export type MultipleIconVariants = {
    solid: Component
    outline: Component
    mini: Component
    micro: Component
}

export function createMultipleIconVariants(icons: MultipleIconVariants): MultipleIconVariants {
    return icons
}

export function createSingleIconVariants(icon: Component): MultipleIconVariants {
    return { solid: icon, outline: icon, mini: icon, micro: icon }
}
